import {Pipe, PipeTransform} from '@angular/core';
import {RoleService} from 'app/blocks/service/api/role.service';
import {Observable} from 'rxjs';

@Pipe({name: 'roleShow', standalone: false})
export class RoleShowPipe implements PipeTransform {
    constructor(private roleService: RoleService) {}
    transform(key: string): Observable<boolean> {
        return this.roleService.subscribeToShowSetting(key);
    }
}

@Pipe({name: 'roleEnable', standalone: false})
export class RoleEnablePipe implements PipeTransform {
    constructor(private roleService: RoleService) {}
    transform(key: string): Observable<boolean> {
        return this.roleService.subscribeToEnableSetting(key);
    }
}
